import { createStore } from "vuex";
import homePage from "./homePage";
export default createStore({
  modules: {
    homePage,
  },
});
